// Space
export type Space = {
  id: string;
};

export type SpaceInfo = {
  owners: string[]; // userIDs
  name?: string;
  description?: string;
  preview?: URL; // image snapshot
  updatedAt?: number; // stored as timestamp
  spatialAudio: boolean;
  cursorSize: number;
  archived?: boolean;
};

export type FeatureFlags = {
  faceSticker: boolean;
  webBlock: boolean;
  edgeScroll: boolean;
  spatialAudio: boolean;
};
export const defaultFeatureFlags: FeatureFlags = {
  faceSticker: false,
  webBlock: true,
  edgeScroll: false,
  spatialAudio: false,
};

export const featureFlagLabels = {
  faceSticker: "Face Stickers (double click!)",
  webBlock: "Interactive Web Block",
  edgeScroll: "Nudge Scroll",
  spatialAudio: "Spatial Audio",
};

// Blocks
export type Block = {
  id: string;
  position: Position; // Vector2D
  size: Size; // Vector2D
  updatedAt: number; // stored as timestamp
  lockedBy?: User; // when editing not sure if needed
  madeBy?: string | undefined; // User Id that created a block
  value?: string | undefined;
  type: BlockType;
};

export type AnyBlock =
  | TextBlock
  | FaceBlock
  | WebBlock
  | ImageBlock
  | ImageSearchBlock
  | LinkBlock
  | CssBlock
  | UndefinedBlock;

export type BlockType =
  | "text"
  | "face"
  | "web"
  | "image"
  | "imageSearch"
  | "link"
  | "css"
  | undefined;

export type UndefinedBlock = Block & {
  type: undefined;
};

export type TextBlock = Block & {
  type: "text";
};

export type FaceBlock = Block & {
  type: "face";
};

export type WebBlock = Block & {
  type: "web";
};

export type ImageBlock = Block & {
  type: "image";
  sticker?: boolean;
};

export type LinkBlock = Block & {
  type: "link";
};

export type ImageSearchBlock = Block & {
  type: "imageSearch";
  text: string;
  searchType: "transparent" | "";
  offset: number;
};

export type CssBlock = Block & {
  type: "css";
};

export type Viewport = {
  position: Position; // Vector2D
  size: Size; // Vector2D
};

export type Preview = {
  position: Position; // Vector2D
  size: Size; // Vector2D
};

// User
export type User = {
  id: string;
  name: string;
  color: string;
  anonymous?: boolean;
  video: boolean;
  audio: boolean;
};

// Presence where key is user ID
export type UserPositions = Record<string, Point2D>;

export type UserOnlines = string[];

export type UserLocations = Record<string, UserLocation>;

export interface UserLocation {
  block?: string;
  position?: Point2D;
  size?: Size;
  locked?: boolean;
}

// Primitives
export type Position = Point2D;

export type Point2D = {
  x: number;
  y: number;
};

export type Size = {
  width: number;
  height: number;
};
